import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import moment from 'moment';
import { isWindowEvent } from 'shared/helpers';
import isEmpty from 'lodash/isEmpty';

const TcCurrentEvent = ({ event, serverDateTime }) => {
  const { t } = useTranslation();
  let daysLeft;

  const getDaysLeft = (eventDate) =>
    moment(eventDate, 'YYYY-MM-DD').diff(moment(serverDateTime, 'YYYY-MM-DD'), 'days');

  if (!isEmpty(event)) {
    if (isWindowEvent(event.testingEvent) && !event.rescheduleDate) {
      daysLeft = 0;

      if (moment(serverDateTime).isBefore(moment(event.testingEvent.testDate), 'day')) {
        daysLeft = getDaysLeft(event.testingEvent.testDate);
      } else if (moment(serverDateTime).isAfter(moment(event.testingEvent.endTestDate), 'day')) {
        daysLeft = getDaysLeft(event.testingEvent.endTestDate);
      }
    } else {
      daysLeft = getDaysLeft(event.rescheduleDate || event.testingEvent.testDate);
    }
  }

  return (
    <section className="curent-test-event">
      <div className="header">
        <div className="title">{t('testCenter.dashboard.currentEventLabel')}</div>
        {!isEmpty(event) ? (
          <div className="days-left">
            <i className="fa fa-info-circle" />
            {Math.abs(daysLeft)}{' '}
            {daysLeft >= 0
              ? t('testCenter.dashboard.daysLeftLabel')
              : t('testCenter.dashboard.daysAfterLabel')}
          </div>
        ) : (
          <div className="no-events">{t('testCenter.dashboard.noCurrentEventLabel')}</div>
        )}
      </div>

      {!isEmpty(event) && (
        <div className="box">
          <div className="test-date">
            <i className="fa fa-calendar" />
            <span>{event.testingEvent.name}</span>
          </div>
          <div className="manage-test-btn">
            <Link to={`/test-event/${event.id}`} href={`/testing-event/${event.id}`}>
              <span>{t('testCenter.dashboard.manageEventBtn')}</span>
              <i className="fa fa-angle-right" />
            </Link>
          </div>
        </div>
      )}
    </section>
  );
};

export default TcCurrentEvent;

TcCurrentEvent.propTypes = {
  event: PropTypes.object.isRequired,
  serverDateTime: PropTypes.string.isRequired,
};
